import CartItems from "../Components/CartItems/CartItems.jsx"

const Cart = () => {
  return (
    <div>
      <CartItems/>
    </div>
  )
}

export default Cart
